module.exports = __webpack_public_path__ + "img/z15.369dc218.png";